import { IconButton, InputAdornment, Typography } from '@material-ui/core';
import styled from 'react-emotion';
export var CustomNumberFieldInputAdornment = styled(InputAdornment)({
    '&&': {
        position: 'absolute',
        right: 55
    }
});
export var SubName = styled(Typography)({
    '&&': {
        opacity: 0.5
    }
});
export var NoPadIconButton = styled(IconButton)({
    '&&': {
        padding: 0
    }
});
export var ErrorText = styled(Typography)({
    '&&': {
        color: 'red'
    }
});
//# sourceMappingURL=MUI.Styles.js.map